export default __webpack_public_path__ + "static/media/chocolate.a04ab43e.jpeg";